import { useCallback } from "react";

import { apiClient, StatusEnum } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const WarehouseSelect = (props) => {
  const fetchWarehouses = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("warehouses", {
      params: {
        status: StatusEnum.ACTIVE,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchWarehouses}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
